<template>
  <v-form ref="form" style="width: 100%;" @keydown.enter="submit" @submit.prevent="register">
    <v-text-field
      :label="$t('common.email')"
      outlined
      v-model="form.email"
      :rules="rules.email"
      data-cy="register-email"
      :prepend-inner-icon="mdiAccount"
      autocomplete="username"
    />
    <PasswordField
      :label="$t('common.password')"
      :rules="rules.password"
      v-model="form.password"
      outlined
      data-cy="register-password"
      autocomplete="new-password"
      class="mb-0"
    />
    <!-- Repeat -->
    <PasswordField
      :prepend-inner-icon="mdiLockOutline"
      :label="$t('common.confirmPassword')"
      :rules="rules.repeat"
      v-model="form.repeat"
      outlined
      filled
      autocomplete="new-password"
      data-cy="register-confirm-password"
    />

    <v-alert type="error" v-for="error in errors" :key="error">
      {{ error }}
    </v-alert>
    <ButtonProgress
      height="50"
      class="primary mb-2 rounded-lg text-capitalize d-block"
      style="width: 100%"
      :loading="isLoading"
      type="submit"
      data-cy="register-buttonRegister"
    >
      {{ $t('common.register') }}
    </ButtonProgress>
  </v-form>
</template>

<script>
import { mapState } from 'vuex';
import { mdiAccount, mdiLock, mdiLockOutline } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import ButtonProgress from '@codehq/aurora-app-core/src/components/ButtonProgress.vue';
import PasswordField from './PasswordField.vue';

export default {
  name: 'Register',
  mixins: [loading],
  components: {
    ButtonProgress,
    PasswordField,
  },
  data() {
    return {
      mdiAccount,
      mdiLock,
      mdiLockOutline,
      form: {
        email: '',
        password: '',
        repeat: '',
        errors: '',
      },
      rules: {
        required: [
          (v) => !!v || 'This field is required',
        ],
        email: [
          (v) => !!v || 'This field is required',
          (v) => /^[A-z0-9\-.]{3}.*@[A-z0-9]*\.[A-z]{2}.*$/gi.test(v) || 'Please provide valid E-Mail',
        ],
        password: [
          (v) => !!v || 'This field is required',
          (v) => v.length > 7 || 'Password should be longer',
        ],
        repeat: [
          (v) => !!v || 'This field is required',
          (v) => v === this.form.password || 'Passwords do not match',
        ],
      },
    };
  },
  computed: {
    ...mapState('app', ['loading']),
  },
  methods: {
    async register() {
      if (this.$refs.form.validate()) {
        try {
          this.isLoading = true;
          const { email, password } = this.form;
          this.$log.info(`Registering ${email}`);
          const registerResult = await this.$auth.register(email, email, password);
          this.$root.$emit('auth:register', registerResult.data);
          this.$log.info(`Logging on ${email}`);
          await this.$auth.login(email, password);
          this.$root.$emit('auth:login', email);
          this.$root.$emit('auth:registerComplete', {
            registerResult: registerResult.data,
            loginResult: email,
          });
        } catch (error) {
          this.errors = error.response.data.modelState[''];
          this.$log.error(error.response.data.error_description);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.c-forget-password {
  text-decoration: underline;
  margin-top: -10px;
}

.c-remembet-me {
  margin-top: -10px !important;
}

h4 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

h4 span {
  background: #fff;
  padding: 0 10px;
}
</style>
